export enum Context {
    // used when we are in basket panel
    Basket = "BASKET",
    // used when we are in (pending/historical) order panel
    Order = "ORDER",
    // used when we are in subscription panel
    Subscription = "SUBSCRIPTION",
    // used when we are in switch subscription panel
    SwitchSubscription = "SWITCH_SUBSCRIPTION",
    // equivalent of 'first-subscription'
    // used when we are in the first subscription (tunnel)
    SubscriptionBasket = "SUBSCRIPTION_BASKET",
    // for specific case when we are in the first subscription (tunnel) or first registration (alc)
    User = "USER",
    UserRegistration = "USER_REGISTRATION"
}

export const SubscriptionContexts = [Context.Subscription, Context.SwitchSubscription, Context.SubscriptionBasket];

export default Context;
